import React from 'react';
import { FormProvider } from 'react-hook-form';
import { DraftAccountDTO, FORM_WIDTH } from '../../AccountOpening.meta';
import { validation } from './BeneficiaryInfo.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Footer } from '../../components/Footer/Footer';
import { Beneficiary } from '../../fields/Beneficiary/Beneficiary';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useStepForm } from '../../hooks/useStepForm';
import { StepContent } from '../../components/StepContent/StepContent';
import { StepCard } from '../../components/StepCard/StepCard';

interface Props {
  draftAccount: DraftAccountDTO;
  onSuccess(): void;
  onPrevious?(): void;
}

export const BeneficiaryInfo: React.FC<Props> = ({ draftAccount, onSuccess, onPrevious }) => {
  const { formBag, saveDraftMutation, onSubmit } = useStepForm({
    draftAccount,
    onSuccess,
    validation,
  });

  return (
    <FormProvider {...formBag}>
      <form onSubmit={formBag.handleSubmit(onSubmit)}>
        <StepContent>
          <StepCard maxWidth={FORM_WIDTH}>
            <Text fontSize="h5" fontWeight={600} mb="32">
              Beneficiary information
            </Text>

            {saveDraftMutation.error && (
              <Alert message={saveDraftMutation.error.message} variant="error" my="32" />
            )}

            <Beneficiary draftAccount={draftAccount} />
          </StepCard>
        </StepContent>

        <Footer isLoading={saveDraftMutation.isLoading} onPrevious={onPrevious} />
      </form>
    </FormProvider>
  );
};
